import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AgentAuthProvider } from "./context/AuthContext";
import AgentProtectedRoute from "./components/ProtectedRoute";
import AgentLayout from "./components/Layout";
import SiteNoticeBanner from "../components/site/SiteNoticeBanner";

import AgentLogin from "./pages/Login";
import AgentDashboard from "./pages/Dashboard";
import DepositToUser from "./pages/DepositToUser";
import UsdtDeposit from "./pages/UsdtDeposit";
import BdtDeposit from "./pages/BdtDeposit";
import BdtDepositReturn from "./pages/BdtDepositReturn";
import PendingWithdrawals from "./pages/PendingWithdrawals";
import History from "./pages/History";
import MyStatements from "./pages/MyStatements";
import ChangePassword from "./pages/ChangePassword";
import TwoFactor from "./pages/TwoFactor";

export default function AgentApp() {
  return (
    <AgentAuthProvider>
      <div className="agent-shell">
        <SiteNoticeBanner />
        <Toaster
          position="top-center"
          richColors closeButton
          toastOptions={{
            style: { background: "#0e1525", color: "white", border: "1px solid rgba(255,255,255,0.08)" },
          }}
        />
        <Routes>
          <Route path="login" element={<AgentLogin />} />
          <Route element={<AgentProtectedRoute><AgentLayout /></AgentProtectedRoute>}>
            <Route index element={<Navigate to="/agent/dashboard" replace />} />
            <Route path="dashboard" element={<AgentDashboard />} />
            <Route path="deposit" element={<DepositToUser />} />
            <Route path="usdt-deposit" element={<UsdtDeposit />} />
            <Route path="bdt-deposit" element={<BdtDeposit />} />
            <Route path="bdt-deposit/return" element={<BdtDepositReturn />} />
            <Route path="withdrawals" element={<PendingWithdrawals />} />
            <Route path="history" element={<History />} />
            <Route path="my-statements" element={<MyStatements />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="two-factor" element={<TwoFactor />} />
            <Route path="*" element={<Navigate to="/agent/dashboard" replace />} />
          </Route>
        </Routes>
      </div>
    </AgentAuthProvider>
  );
}
